import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
  path: {
    fill: '#ffffff',
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  // Draeger "D" icon - simplified version for collapsed sidebar
  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17.31 29.07"
    >
      <path
        className={classes.path}
        d="M0,.72v2.97h9.13c1.06,0,1.59.21,2.12.74.43.53.43.74.43,2.65v15.29c0,2.87-.53,3.4-3.08,3.4h-2.55V6.67H0v22.4h11.26c2.65,0,3.4-.21,4.67-1.49,1.17-1.17,1.38-2.02,1.38-5.31V6.24c0-2.02-.21-2.76-1.06-3.82-1.06-1.17-2.44-1.7-4.35-1.7H0Z"
      />
    </svg>
  );
};

export default LogoIcon;
